const breakpoint = 991;

export default breakpoint